import { useState, useEffect, useRef } from 'react';

import {
  getNumberOfUnseenAlerts,
  invalidateMozartNotifications,
} from 'features/mozart-notifications/infra';
import { useMozartButtonLang } from './useMozartButtonLang';

export function useMozartButton() {
  const [animatePulse, setAnimatePulse] = useState(false);
  const [animateLabel, setAnimateLabel] = useState(false);

  const prevAlertsCountRef = useRef(0);
  const unseenAlerts = getNumberOfUnseenAlerts();

  useEffect(() => {
    if (unseenAlerts.amount > prevAlertsCountRef.current) {
      setAnimatePulse(true);
      invalidateMozartNotifications();
      const labelTimeoutId = setTimeout(() => {
        setAnimatePulse(false);
        setAnimateLabel(true);
        const resetTimeoutId = setTimeout(() => {
          setAnimateLabel(false);
        }, 5_250);
        return () => clearTimeout(resetTimeoutId);
      }, 1_500);
      return () => clearTimeout(labelTimeoutId);
    }
    prevAlertsCountRef.current = unseenAlerts.amount;
  }, [unseenAlerts.amount]);

  const lang = useMozartButtonLang();

  return {
    lang,
    animatePulse,
    animateLabel,
    unseenAlerts,
  };
}
